import { GoogleMapa } from '../componentes/googleMaps';
import {default as turfJsCircle} from '@turf/circle';

export class Cerca {
    constructor() {
        this._googleMaps      = new GoogleMapa('carregarMapaAqui');
        this._drawingManager  = undefined;
        this._circuloAtual    = undefined;
        this._poligonoAtual   = undefined;
        this._btnDeletarCerca = false;
    }

    iniciarMapa() {
        this._googleMaps.iniciarMapa();
        this._iniciarDrawingManager();
        this._cercaGeograficaFormatoCirculoCriada();
        this._cercaGeograficaFormatoPoligonoCriada();
        this._desenharCerca();
    }

    _iniciarDrawingManager() {
        const configuracao = {
            drawingControl: true,
            drawingMode   : google.maps.drawing.OverlayType.MARKER,
            drawingControlOptions: {
                position    : google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                    google.maps.drawing.OverlayType.CIRCLE,
                    google.maps.drawing.OverlayType.POLYGON,
                ],
            },
            circleOptions: {
                clickable: false,
                editable : true,
            },
            polygonOptions: {
                clickable: false,
                editable : true,
            },
        };

        this._drawingManager = new google.maps.drawing.DrawingManager(configuracao);
        this._drawingManager.setMap(this._googleMaps.instanciaMapa);
    }

    _cercaGeograficaFormatoCirculoCriada() {
        google.maps.event.addListener(this._drawingManager, 'circlecomplete', (poligonoCirculo) => {
            this._criarBtnDeletarCercaGeografica();
            this._poligonoAtual?.setMap(null);
            this._circuloAtual?.setMap(null);

            this._addValorInputPoligono(this._converterCirculoPoligono(poligonoCirculo));
            this._addValorInputLatitude(poligonoCirculo.getCenter().lat());
            this._addValorInputLongitude(poligonoCirculo.getCenter().lng());
            this._addValorInputRaio(poligonoCirculo.getRadius());
            this._addValorInputTipoPoligono('circulo');

            this._circuloAtual = poligonoCirculo;
            this._drawingManager.setDrawingMode(null);
        });
    }

    _cercaGeograficaFormatoPoligonoCriada() {
        google.maps.event.addListener(this._drawingManager, 'polygoncomplete', (polygon) => {
            this._removerValorInputRaio();

            this._criarBtnDeletarCercaGeografica();
            this._poligonoAtual?.setMap(null);
            this._circuloAtual?.setMap(null);

            const dadosPoligono = this._extrairDadosPoligono(polygon);
            this._addValorInputPoligono(dadosPoligono?.coordenadas);
            this._addValorInputLongitude(dadosPoligono?.longitude);
            this._addValorInputLatitude(dadosPoligono?.latitude);
            this._addValorInputTipoPoligono('poligono');

            this._poligonoAtual = polygon;
            this._drawingManager.setDrawingMode(null);
        });
    }

    _criarBtnDeletarCercaGeografica() {
        if (this._btnDeletarCerca === true) {
            return;
        }

        const novoBotao     = this._criarBotao();
        novoBotao.innerHTML = '<i class="fa fa-trash"></i>';
        novoBotao.title     = 'Deletar cerca';

        novoBotao.classList.add('btn', 'btn-square');
        novoBotao.addEventListener('click', () => {
            this._circuloAtual?.setMap(null);
            this._poligonoAtual?.setMap(null);
            this._removerValorInputTipoPoligono();
            this._removerValorInputLongitude();
            this._removerValorInputLatitude();
            this._removerValorInputPoligono();
            this._removerValorInputRaio();
        });

        this._btnDeletarCerca = true;
        this._googleMaps.instanciaMapa
        .controls[google.maps.ControlPosition.TOP_RIGHT].push(novoBotao);
    }

    _criarBotao() {
        const htmlBtnElement = document.createElement('button');

        htmlBtnElement.style.backgroundColor = '#fff';
        htmlBtnElement.style.boxShadow       = '0 2px 6px rgba(0,0,0,.3)';
        htmlBtnElement.style.color           = 'rgb(25,25,25)';
        htmlBtnElement.style.margin          = '8px 10px 5px 0';
        htmlBtnElement.type                  = 'button';

        return htmlBtnElement;
    }

    /**
     * Um polígono deve conter pelo menos 4 coordenadas, a primeira e ultima coordenada
     * devem ser iguais.
     *
     * A latitude e longitude correspondem ao centro do poligono.
     *
     * @param poligono
     * @returns {object}
     * @private
     */
    _extrairDadosPoligono(poligono) {
        if (!poligono) {
            return undefined;
        }

        const arrayLatLng = poligono.getPath().getArray();
        const bounds 	  = new google.maps.LatLngBounds();
        const coordenadas = [];

        for (let indice = 0; indice < arrayLatLng.length; indice++) {
            coordenadas.push({lat: arrayLatLng[indice].lat(), lng: arrayLatLng[indice].lng()})
            bounds.extend(arrayLatLng[indice]);
        }

        const ultimaCoordenada   = coordenadas[coordenadas.length - 1];
        const primeiraCoordenada = coordenadas[0];
        if (primeiraCoordenada.lat !== ultimaCoordenada.lat
        || primeiraCoordenada.lng !== ultimaCoordenada.lng) {
            coordenadas.push(primeiraCoordenada);
        }

        return {
            latitude   : bounds.getCenter().lat(),
            longitude  : bounds.getCenter().lng(),
            coordenadas: JSON.stringify(coordenadas),
        };
    }

    _desenharCerca() {
        const latitude  = document.getElementById('latitude').value;
        const longitude = document.getElementById('longitude').value;
        const poligono  = document.getElementById('poligono').value;
        const raio      = document.getElementById('raio').value;
        const tipo      = document.getElementById('tipo').value;

        if (tipo === 'circulo' && latitude && longitude && raio) {
            this._circuloAtual = new google.maps.Circle({
                center: { lat: parseFloat(latitude), lng: parseFloat(longitude) },
                map   : this._googleMaps.instanciaMapa,
                radius: parseFloat(raio),
            });

            this._googleMaps.instanciaMapa.fitBounds(this._circuloAtual.getBounds());
        }

        if (tipo === 'poligono' && latitude && longitude && poligono) {
            this._poligonoAtual = new google.maps.Polygon({
                map   : this._googleMaps.instanciaMapa,
                paths : JSON.parse(poligono),
                radius: parseFloat(raio),
            });

            this._googleMaps.instanciaMapa.fitBounds(this._polygonGetBounds());
        }
    }

    _converterCirculoPoligono(poligonoCirculo) {
        const centro   = [poligonoCirculo.getCenter().lng(), poligonoCirculo.getCenter().lat()];
        const radius   = poligonoCirculo.getRadius();
        const cerca    = turfJsCircle(centro, radius, {units: 'meters'});
        const resposta = [];

       if (Array.isArray(cerca.geometry.coordinates)) {
            cerca.geometry.coordinates[0].forEach((coordenada) => {
                resposta.push({lat: coordenada[1], lng: coordenada[0]});
            });

            return JSON.stringify(resposta);
        }

        return '';
    }

    _polygonGetBounds() {
        const arrayLatLng = this._poligonoAtual.getPath().getArray();
        const bounds 	  = new google.maps.LatLngBounds();
        for (let indice = 0; indice < arrayLatLng.length; indice++) {
            bounds.extend(arrayLatLng[indice]);
        }

        return bounds;
    }

    _addValorInputLatitude(latitude) {
        if (typeof latitude === 'number') {
            document.getElementById('latitude').value = latitude;
        }
    }

    _addValorInputLongitude(longitude) {
        if (typeof longitude === 'number') {
            document.getElementById('longitude').value = longitude;
        }
    }

    _addValorInputRaio(raio) {
        if (typeof raio === 'number') {
            document.getElementById('raio').value = raio;
        }
    }

    _addValorInputTipoPoligono(tipoPoligono) {
        if (typeof tipoPoligono === 'string' && tipoPoligono) {
            document.getElementById('tipo').value = tipoPoligono;
        }
    }

    _addValorInputPoligono(poligono) {
        if (typeof poligono === 'string' && poligono) {
            document.getElementById('poligono').value = poligono;
        }
    }

    _removerValorInputLatitude() {
        document.getElementById('latitude').value = '';
    }

    _removerValorInputLongitude() {
        document.getElementById('longitude').value = '';
    }

    _removerValorInputRaio() {
        document.getElementById('raio').value = '';
    }

    _removerValorInputTipoPoligono() {
        document.getElementById('tipo').value = '';
    }

    _removerValorInputPoligono() {
        document.getElementById('poligono').value = '';
    }
}
